<template>
  <v-form ref="form" v-model="valid">
    <v-card outlined>
      <v-card-title>
        {{ $t("auditor.stepModelRequirementsResultForm.title") }}
      </v-card-title>

      <v-card-text>
        <MarkdownEditor
          v-model="formData.stepModelRequirementsText"
          :rules="[(v) => !!v || $t('validation.required')]"
          @change="save"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click="save" :disabled="!valid">
          {{ $t("auditor.stepModelRequirementsResultForm.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import UpdateFundResultMutation from "@/gql/mutations/UpdateFundResultMutation.gql";
import MarkdownEditor from "@/components/Common/MarkdownEditor.vue";

export default {
  components: {
    MarkdownEditor,
  },

  props: {
    fund: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: null,
      valid: false,
      loading: false,
    };
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      await this.$apollo.mutate({
        mutation: UpdateFundResultMutation,
        variables: {
          id: this.fund.id,
          input: this.formData,
        },
      });

      this.loading = false;
      this.$emit("save");
    },
  },

  created() {
    this.formData = this.fund.result
      ? {
          stepModelRequirementsText: this.fund.result.stepModelRequirementsText,
        }
      : {
          stepModelRequirementsText: null,
        };
  },
};
</script>
